import { columns } from "@/components/tables/builds/columns";
import { DataTable } from "@/components/tables/builds/table";
import { httpClient } from "@/lib/http-client";
import { HydrationBoundary, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "@/lib/paraglide-react";
import { Route } from "/app/src/routes/{-$locale}/items/$id/builds.tsx";
function ItemBuildsPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  const [page, setPage] = useState({
    pageIndex: 0,
    pageSize: 20
  });
  const [filters, setFilters] = useState<ColumnFiltersState>([]);
  const {
    data: builds
  } = useQuery({
    queryKey: ["item", "builds", {
      id
    }],
    queryFn: () => httpClient.get<Build[]>(`/items/${id}/builds`).catch(() => [])
  });
  if (!builds) {
    return null;
  }
  return <div className="flex flex-col items-start justify-start h-full gap-4 w-full">
      <h2 className="text-xl font-bold">{t("items.builds.title")}</h2>
      <DataTable<Build, unknown> columns={columns} data={builds} setPage={setPage} page={page} total={builds.length} filters={filters} setFilters={setFilters} />
    </div>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  return <HydrationBoundary state={dehydratedState}>
        <ItemBuildsPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };